import { SwiperOptions } from 'swiper/types';
import { queryAllHtmlElement } from './base/query-all-html-element.ts';
import { queryHtmlElement } from './base/query-html-element.ts';
import { BreakpointName, breakpointNames } from './breakpoints.ts';
import { Expander } from './components/expander/expander.ts';
import { Module } from './components/module/module.ts';
import { CustomSwiper } from './components/swiper/custom-swiper.ts';

const onReady = () => {
  // create animation when module contents enter viewport when scrolling
  queryAllHtmlElement(document, '.viewport-entry-animate').forEach(elModule => new Module(elModule));

  // create content expanders functionality
  for (const elExpander of queryAllHtmlElement(document, '.expander--generic')) {
    const sizes = (elExpander.dataset['expanderSizes']?.split(' ') || [])
      .filter((size): size is BreakpointName => !!size && breakpointNames.includes(size as BreakpointName));
    new Expander(elExpander, sizes);
  }

  // create swiper instances
  for (const el of queryAllHtmlElement(document, '.swiper--generic')) {
    // const config: {
    // 	grabCursor: boolean;
    // 	navigation?: { prevEl: Element | null, nextEl: Element | null };
    // 	on?: { init: () => void, resize: () => void };
    // } = {
    // 	grabCursor: true
    // };
    const config: SwiperOptions = {
      grabCursor: true,
    };

    // if parent node is '.swiper--generic__wrapper', configure any elements outside of the swiper
    if (el.parentElement?.classList.contains('swiper--generic__wrapper')) {
      // identify navigation buttons (prev/next)
      if ('navigation' in el.dataset) {
        config.navigation = {
          prevEl: queryHtmlElement(el.parentElement, '.swiper-button-prev'),
          nextEl: queryHtmlElement(el.parentElement, '.swiper-button-next'),
        };
      }
    }

    // // record tiles that have already been registered as Tile objects
    // const tileized = new Set();

    // // If this is a slider of tiles, create the Tile objects on init and on resize.
    // config.on = {
    // 	init: function () { // not arrow function! - need to create internal scope to inherit swiper instance
    // 		this.slides.each(slide => {
    // 			tileized.add(slide);
    // 			new Tiles(slide.querySelectorAll(".tile"));
    // 		});
    // 	},
    // 	resize: function () {
    // 		this.slides.each(slide => {
    // 			if (!tileized.has(slide)) {
    // 				tileized.add(slide);
    // 				new Tiles(slide.querySelectorAll(".tile"), true);
    // 			}
    // 		});
    // 	},
    // };

    new CustomSwiper(el, config);
  }
};

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', onReady) : onReady();
